import { useState, useEffect } from "react";
import { getCategories } from "../../service/api";
import PageLayout from "./common/PageApp";
import "swiper/css";
import "swiper/css/navigation";

function Category() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCategories()
      .then((res) => {
        console.log("Categories API response:", res);

        // Response structure: { status, message, totalRecord, data: [...] }
        if (Array.isArray(res.data?.data)) {
          setCategories(res.data.data);
        } else {
          console.warn("Unexpected response format:", res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <PageLayout>
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Job Category</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="categories pt-50 pb-50">
        <div className="site-width">
          <div className="titleSection text-center wow animate__fadeInDown">
            <h2>Browse by category</h2>
            <p>New Cotegories</p>
          </div>

          {loading ? (
            <p>Loading categories...</p>
          ) : categories.length === 0 ? (
            <p>No categories found</p>
          ) : (
            <div className="categoriesGrid row">
              {categories.map((category) => (
                <div className="col-md-4 mb-2">
                  <a
                    key={category.id}
                    href={`/job-category/${category.id}`}
                    className="categoryLink"
                  >
                    <div className="categoryCard wow animate__zoomIn">
                      <div className="categoryHeader">
                        <div className="categoryImg">
                          <img
                            src={
                              category.image ||
                              "/assets/img/icons/human-resource.png"
                            }
                            alt={category.name}
                          />
                        </div>
                        <div className="categoryContent">
                          <h4 style={{ fontSize: "15px" }}>{category.name}</h4>
                          <p style={{ fontSize: "13px" }}>
                            {category.jobCount}{" "}
                            {category.jobCount === 1 ? "Job" : "Jobs"} Available
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          )}

        </div>
      </section>
    </PageLayout>
  );
}

export default Category;
